module.exports = __webpack_public_path__ + "img/chair_breakdown_thumb.e8284f21.jpg";